import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MdAreaChart, MdOutlineBarChart, MdOutlineShowChart } from 'react-icons/md'
import { useSearchParams } from 'react-router-dom'

export default function FutureMineralPricesChartTypeSelect({ onChange }) {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedType, setSelectedType] = useState('AREA')
  function handleOnClick(type) {
    setSelectedType(type)
    searchParams.set('CHART', type)
    setSearchParams(searchParams)
  }
  return (
    <div className="flex flex-col space-y-2 rtl:space-x-reverse">
      <label className={`font-bold`}>{t('CHART_TYPE')}</label>
      <div className="flex space-x-2 rtl:space-x-reverse">
        <button
          onClick={() => handleOnClick('AREA')}
          className={`border-2 font-bold ${selectedType == 'AREA' ? 'border-secondary-600 text-secondary-600 bg-light' : 'hover:border-secondary-600 hover:text-secondary-600 hover:bg-light'} p-1.5`}
        >
          <MdAreaChart size={22} />
        </button>
        <button
          onClick={() => handleOnClick('BAR')}
          className={`border-2 font-bold ${selectedType == 'BAR' ? 'border-secondary-600 text-secondary-600 bg-light' : 'hover:border-secondary-600 hover:text-secondary-600 hover:bg-light'} p-1.5`}
        >
          <MdOutlineBarChart size={22} />
        </button>
        <button
          onClick={() => handleOnClick('LINE')}
          className={`border-2 font-bold ${selectedType == 'LINE' ? 'border-secondary-600 text-secondary-600 bg-light' : 'hover:border-secondary-600 hover:text-secondary-600 hover:bg-light'} p-1.5`}
        >
          <MdOutlineShowChart size={22} />
        </button>
      </div>
    </div>
  )
}
